var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLibraryDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 1H3.57143C2.88944 1 2.23539 1.2867 1.75315 1.79704C1.27092 2.30738 1 2.99954 1 3.72127V24.3185C1.00004 24.4377 1.02963 24.5547 1.08583 24.6579C1.14203 24.7612 1.22286 24.847 1.32023 24.9068C1.41761 24.9666 1.52811 24.9982 1.64068 24.9986C1.75326 24.999 1.86396 24.9681 1.96171 24.9091L8.72457 20.8204C9.11302 20.5855 9.55264 20.462 10 20.462C10.4474 20.462 10.887 20.5855 11.2754 20.8204L18.0383 24.9104C18.1361 24.9696 18.247 25.0005 18.3596 25C18.4723 24.9995 18.5829 24.9677 18.6803 24.9078C18.7777 24.8478 18.8585 24.7618 18.9146 24.6584C18.9708 24.555 19.0002 24.4378 19 24.3185V3.72127C19 2.99954 18.7291 2.30738 18.2468 1.79704C17.7646 1.2867 17.1106 1 16.4286 1Z",
    stroke: "#8B909A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLibraryDropdown);
export default __webpack_public_path__ + "static/media/MyLibraryDropdown.e09db64ad9f67570f58a8a23081e31d9.svg";
export { ForwardRef as ReactComponent };